@if (config?.submittedClaimReference) {
  <header class="ClaimDetail__MobileHeader">
    <a
      class="ClaimDetail__MobileHeaderBack"
      [routerLink]="config.submittedClaimReference.submittedClaimsUrl"
    >
      <icon
        [name]="config.submittedClaimReference.mobileBackIcon?.name"
        [config]="config.submittedClaimReference.mobileBackIcon?.iconConfig"
      >
      </icon>
    </a>
    <div class="ClaimDetail__MobileHeaderTitle">
      {{ config.submittedClaimReference.title }}{{ claimNumber }}
    </div>
  </header>
}
@if (config?.submittedClaimReference) {
  <a
    class="ClaimDetail__Header"
    [routerLink]="config.submittedClaimReference.submittedClaimsUrl"
  >
    <zip-button
      [config]="config.submittedClaimReference.backButton"
      data-test-id="submittedClaimDetailBackButton"
    ></zip-button>
  </a>
  <div class="ClaimDetail__Body">
    <div class="ClaimDetail__Description">
      <h4 class="t-bold">
        {{ config.submittedClaimReference.title }}{{ claimNumber }}
      </h4>
    </div>
    <lib-claim-submission-review
      [config]="config"
      [claimId]="claimId"
      [isEditable]="false"
      [submittedClaimContext]="submittedClaimContext"
    ></lib-claim-submission-review>
  </div>
}
